<template>
  <div id="tab_tracking" class="tab-pane fade in active">
    <div class="tab__header">Tracking Sheet</div>
    <Comparisons></Comparisons>
    <TrackingSheetTable title="KPI Tracking" :metrics="metricsKpiTracking"></TrackingSheetTable>
    <TrackingSheetTable title="Practice Locations & Provider Information" :metrics="metricsLocationsAndProviders"></TrackingSheetTable>
    <TrackingSheetTable title="Testing Statistics" :metrics="metricsTestingStatistics"></TrackingSheetTable>
    <TrackingSheetTable title="Treatment Statistics" :metrics="metricsTreatmentStatistics"></TrackingSheetTable>

    <div class="tab__sub-header">BENCHMARK CLASSIFICATION</div>
    <div class="kpi-table-wrapper">
      <table class="kpi-table">
        <tr class="kpi-table__header">
          <th v-for="month in monthAbbrevs">{{ month }}</th>
        </tr>
        <tr class="kpi-table__metric">
          <td v-for="(month, index) in curYear" v-bind:class="[month.month === curMonth.month ? 'kpi-performance-table__month--selected' : '']">
            {{ month.size }}
          </td>
          <td v-for="month in emptyMonthsUntilEndOfYear"> - </td>
        </tr>
      </table>
    </div>
    <div class="legend">
      <span class="benchmark-size__label label label-info">X Large</span> = 20+ Physicians &nbsp;&nbsp;&nbsp;
      <span class="benchmark-size__label label label-info">Large</span> = 11-20 Physicians &nbsp;&nbsp;&nbsp;
      <span class="benchmark-size__label label label-info">Medium</span> = 5–10 Physicians &nbsp;&nbsp;&nbsp;
      <span class="benchmark-size__label label label-info">Small</span> = 1–4 Physicians &nbsp;&nbsp;&nbsp;
    </div>
  </div>
</template>

<script>
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';
  import Comparisons from './Comparisons.vue';
  import TrackingSheetTable from './tracking-sheet/TrackingSheetTable.vue';

  export default {
    name: 'Tracking',
    components: {
      Comparisons,
      TrackingSheetTable,
    },
    computed: {
      ...mapGetters('allergyKpis', [
        'curMonth',
        'curYear',
        'monthAbbrevs',
        'monthsInReport',
        'metricsKpiTracking',
        'metricsLocationsAndProviders',
        'metricsTestingStatistics',
        'metricsTreatmentStatistics',
      ]),
      emptyMonthsUntilEndOfYear() {
        // Init empty array
        var months = [];
        var emptyMonth = this.shallowCopy(this.curYear[0], 0);

        // If months with data in report is less than 12, add empty months as necessary
        if (parseInt(this.curYear.length) < 12) {
          for (var i = this.curYear.length; i < 12; i++) {
            months.push({ month: i, ...emptyMonth });
          }
        }
        return months;
      },
    },
    methods: {
      /**
       *  Makes a copy of an object.
       *
       *  @param original The object to copy.
       *  @param overrideValue A value if you want the new object's properties to all be set to a fixed value.
       */
      shallowCopy (original, overrideValue = false) {
        return lodash.mapValues({...original}, () => overrideValue);
      },
    },
  };
</script>
